import { getById } from '@/services/api';
import { queryCurrent } from '@/services/user';
import { stashPortalLoginConfig } from '@/utils/infrastructure/auth';
import { buildPortalPath } from '@/utils/infrastructure/utilities';
import { queryAllowedSites } from '@/pages/user/business/service';

const asList = (res) => {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.items)) return res.items;
  if (Array.isArray(res?.value)) return res.value;
  return [];
};

/**
 * After `/user/login?portal=:id` the tab only has the id. Resolve slugs from
 * allowed portals + the signed-in company so we can enter `/p/:company/:portal`.
 */
export async function fetchPortalEntryById(portalId) {
  if (!portalId) return null;
  try {
    const [sites, user] = await Promise.all([
      queryAllowedSites({}).catch(() => null),
      queryCurrent(true),
    ]);
    let site = asList(sites).find((item) => String(item?.id) === String(portalId));
    if (!site?.shortCode) {
      site = await getById({
        id: portalId,
        route: 'processPortal',
        params: { select: 'id,name,shortCode,logoUrl,faviconUrl,mainColor,loginSplashUrl' },
      });
    }
    const companyCode = user?.company?.shortCode;
    const portalCode = site?.shortCode;
    if (!companyCode || !portalCode) return null;

    const config = {
      ...site,
      companyCode,
      portalCode,
    };
    stashPortalLoginConfig(config);
    const path = buildPortalPath(companyCode, portalCode);
    return path ? { path, config } : null;
  } catch (e) {
    return null;
  }
}
